import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import CreativeImage from "./CreativeImage";
import { writeBatch, doc, collection, getDocs } from "firebase/firestore";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import { db, storage, app } from "../firebase";

import axios from "axios";
import cheerio from "cheerio";
export default function ConventionAndTreaties() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page2, setPage2] = useState(0);
  const [rowsPerPage2, setRowsPerPage2] = useState(5);
  const [page3, setPage3] = useState(0);
  const [rowsPerPage3, setRowsPerPage3] = useState(5);
  const [rows, setRows] = useState([]);
  const [rows2, setRows2] = useState([]);
  const [rows3, setRows3] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage);
  };

  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(parseInt(event.target.value, 10));
    setPage2(0);
  };
  const handleChangePage3 = (event, newPage) => {
    setPage3(newPage);
  };

  const handleChangeRowsPerPage3 = (event) => {
    setRowsPerPage3(parseInt(event.target.value, 10));
    setPage3(0);
  };

  const fetchTreatiess = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "treaties"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setRows3(treaties);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const fetchGenevaConvention = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "genevaconvention"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const fetched = treaties.sort((a, b) =>
        a.country.localeCompare(b.country)
      );
      setRows(fetched);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const fetchViennaConvention = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "viennaconvention"));
      const treaties = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const fetched = treaties.sort((a, b) =>
        a.country.localeCompare(b.country)
      );
      setRows2(fetched);
      return treaties; // Return the array of treaty documents
    } catch (error) {
      console.error("Error fetching treaties:", error);
      return []; // Return empty array on error
    }
  };
  const GenevaPartiesDirect = rows.filter((row) => row.country.trim() !== "");
  const ViennaConvention = rows2.filter((row) => row.country.trim() !== "");
  const Treaties = rows3.filter((row) => row.treaty.trim() !== "");

  useEffect(() => {
    // const batch = writeBatch(db); // Create a batch write object
    // rows2.forEach((treatyData) => {
    //   const newDocRef = doc(collection(db, "viennaconvention")); // Create a new document reference in the "treaties" collection
    //   batch.set(newDocRef, treatyData); // Add data to the batch
    // });
    // batch.commit(); // Commit the batch
    fetchViennaConvention();
    fetchGenevaConvention();
    fetchTreatiess();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,

        backgroundColor: "#212C62",
      }}
    >
      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>Diplomatic Conventions And Treaties</b>
            </h1>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>List of parties to the Geneva Conventions : </b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Country</TableCell>
                  <TableCell align="right">
                    Year of ratification/accession/succession
                  </TableCell>
                  <TableCell align="right">Declaration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {GenevaPartiesDirect.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <a
                        className="colorst"
                        target="_blank"
                        href={row.countryLink}
                      >
                        {row.country}
                      </a>
                    </TableCell>
                    <TableCell align="right">{row.dateOfAdhesion}</TableCell>
                    <TableCell align="right">{row.notes}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>
              List of parties to the Vienna Convention on the Law of Treaties :
            </b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>State</TableCell>
                  <TableCell align="right">Signed</TableCell>
                  <TableCell align="right">Deposited</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ViennaConvention.slice(
                  page2 * rowsPerPage2,
                  page2 * rowsPerPage2 + rowsPerPage2
                ).map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <a
                        className="colorst"
                        target="_blank"
                        href={row.countryLink}
                      >
                        {row.country}
                      </a>
                    </TableCell>
                    <TableCell align="right">{row.dateOfAdhesion}</TableCell>
                    <TableCell align="right">{row.notes}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={rows2.length}
            rowsPerPage={rowsPerPage2}
            page={page2}
            onPageChange={handleChangePage2}
            onRowsPerPageChange={handleChangeRowsPerPage2}
          />
        </Paper>
        <div className="mt-5">
          <h5 style={{ color: "212C62" }}>
            <b>List of Treaties :</b>
          </h5>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Year</TableCell>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="left">Summary</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Treaties.slice(
                  page3 * rowsPerPage3,
                  page3 * rowsPerPage3 + rowsPerPage3
                ).map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.treaty}
                    </TableCell>
                    <TableCell align="left">
                      <a
                        className="colorst"
                        target="_blank"
                        href={row.treatyLink}
                      >
                        {row.dateSigned}
                      </a>
                    </TableCell>
                    <TableCell align="left">{row.entryIntoForce}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={rows3.length}
            rowsPerPage={rowsPerPage3}
            page={page3}
            onPageChange={handleChangePage3}
            onRowsPerPageChange={handleChangeRowsPerPage3}
          />
        </Paper>
      </Card>
    </div>
  );
}
